import { IAuth, IUser } from "@grassrootly/api/entities";
import { provider } from "@grassrootly/api/providers";

export type RefreshAuthPayload = {
  refresh_token: string;
};

export type RefreshAuthResponse = {
  auth: IAuth;
  user: IUser;
};

export const RefreshAuth = async (params: RefreshAuthPayload): Promise<RefreshAuthResponse> =>
  provider.Request<RefreshAuthPayload, RefreshAuthResponse>("/auth/refresh", params);
